import { useState, useEffect } from 'react';
import { usePrivacidadStore } from '../store/auth';
import { formatCurrency, formatCurrencyCompacto } from '../utils/formatters';
import { activable, FOCO } from '../utils/a11y';

// Máscara de longitud fija: si dependiera del número real, la cantidad de
// puntos delataría la magnitud (mil vs. cien mil).
export const MASCARA = '$ ••••••';

// Muestra una cantidad de dinero. Con el modo privacidad activo (icono del ojo
// en el Navbar) la sustituye por la máscara: a diferencia del blur, el número
// no queda en pantalla de ninguna forma recuperable. Un clic (o Enter/Espacio
// con el foco) la revela y otro la vuelve a ocultar.
export function Monto({ value, decimales = 0, className = '' }) {
  const modoPrivado = usePrivacidadStore(s => s.modoPrivado);
  const [revelado, setRevelado] = useState(false);

  // Sin esto, un monto revelado seguía en claro al apagar y volver a encender
  // el modo, y en listas con key por índice se quedaba revelada la posición,
  // mostrando el dato de otra fila.
  useEffect(() => { setRevelado(false); }, [modoPrivado, value]);

  const oculto = modoPrivado && !revelado;

  return (
    <span
      {...activable(modoPrivado ? (e) => { e.stopPropagation(); setRevelado(r => !r); } : undefined,
        { label: oculto ? 'Cantidad oculta, mostrar' : undefined, pressed: modoPrivado ? revelado : undefined })}
      title={modoPrivado ? (revelado ? 'Clic para ocultar' : 'Clic para ver') : undefined}
      className={`inline-block tabular-nums ${modoPrivado ? `cursor-pointer rounded ${FOCO}` : ''} ${oculto ? 'select-none tracking-tight' : ''} ${className}`}
    >
      {oculto ? MASCARA : formatCurrency(value, decimales)}
    </span>
  );
}

// Para los montos que van dentro de un string (frases, tooltips, ejes de
// gráficas) y por tanto no pueden llevar <Monto>.
export function useMontoTexto() {
  const modoPrivado = usePrivacidadStore(s => s.modoPrivado);
  return (value, decimales = 0) => (modoPrivado ? MASCARA : formatCurrency(value, decimales));
}

// Ejes de gráficas: misma máscara, cifra compacta ($12.5 k) para que quepa en el eje.
export function useMontoCompacto() {
  const modoPrivado = usePrivacidadStore(s => s.modoPrivado);
  return (value) => (modoPrivado ? MASCARA : formatCurrencyCompacto(value));
}

export default Monto;
